export default __webpack_public_path__ + "static/media/(26).2e0d9c11.jpeg";